module.exports = __webpack_public_path__ + "img/aboservice-v3.5ef899a0.jpg";